import { CommonTranslation, ExtranetTranslation } from './finnish'

export const languageSv: ExtranetTranslation = {
  pageTitle: 'OmaPro Portalen',
  menu: {
    home: 'Hem',
    services: 'Tjänster',
    omaAnnosServices: 'Oma-annos tjänster',
    omaAnnosService: 'Oma-annos tjänst',
    omaAnnosOrders: 'Beställningar',
    omaAnnosOrderHistory: 'Beställningshistorik',
    omaAnnosOrderSchedules: 'Beställningstidtabell / Avvikelser i tidtabellen',
    omaAnnosProducts: 'Läkemedelssortiment',
    omaAnnosPhysicalProducts: 'Beställning av dosdispenseringsmaterial',
    omaAnnosOrderTickets: 'Korrigeringsförfrågningar',
    omaAnnosProductShortages: 'Läkemedelsbrister',
    omaAnnosCustomership: 'Mitt kundkonto',
    omaAnnosCustomerGroupManagement: 'Administration av kundgruppen',
    omaProServices: 'OmaPro-tjänster',
    omaProMobile: 'OmaPro Mobil',
    medicineIdentification: 'Läkemedelsidentifiering',
    support: 'Stöd',
    newsletters: 'Aktuellt',
    faq: 'Vanliga frågor',
    contact: 'Kontakta oss',
    materials: 'Material',
    shop: 'Butik',
  },
  userMenu: {
    ownCustomership: 'Mitt kundkonto',
    changeCustomership: 'Byt kund',
    selectLanguage: 'Välj språk',
    logout: 'Logga ut',
    infoAndUsers: 'Företagsinformation och användare',
    deliveryDetails: 'Leveransspecifikationer',
  },
  newsletters: {
    title: 'Aktuellt',
    allNewsletters: 'Visa alla aktuellt',
  },
  faq: {
    title: 'Vanliga frågor',
  },
  user: {
    title: 'Mina uppgifter',
    userRoles: 'Användarroller',
    marketingAuthorization: 'Marknadsföringstillstånd',
    marketingAuthorizationInfo:
      'Med detta samtycke håller du dig uppdaterad om nya produkter, tjänster och erbjudanden som kan vara av intresse för dig. Du kan när som helst dra tillbaka samtycket.',
    marketingAuthorizationApproved: 'Marknadsföringstillstånd godkändes den',
    privacyPolicy: 'Dataskyddsbeskrivningen',
    privacyPolicyInfo:
      'Läs hur vi behandlar dina uppgifter på ett säkert och konfidentiellt sätt. Acceptera meddelandet för att fortsätta.',
    privacyPolicyLinkText: 'Dataskyddsbeskrivning för OmaPro-tjänsten',
    privacyPolicyApproved: 'Dataskyddsbeskrivning godkändes den',
    cookies: 'Cookies',
    cookieInfo:
      'Vi samlar in cookies för besöksuppföljning och marknadsföring. Accepterar du cookiepolicyn?',
    termsOfUse: 'Användarvillkor',
    termsOfUseInfo:
      'Vi tillämpar följande användarvillkor för tjänsten. Efter att du har bekantat dig med dem och godkänt dem kan du fortsätta.',
    termsOfUseLinkText: 'Användarvillkor för OmaPro-tjänsten',
    termsOfUseApproved: 'Användarvillkor godkändes den',
    infoUpdatedSuccessfully: 'Redigering av användaruppgifter lyckades',
    deletedSuccessfully: 'Borttagning av användare lyckades',
    approvalChangedSuccessfully: 'Samtycken har ändrats framgångsrikt',
    approvalModalTitle:
      'Fortsätt inloggningen genom att godkänna Dataskyddsbeskrivning och Användarvillkor',
  },
  medicines: {
    title: 'Läkemedelssortiment',
    productNumber: 'Produkt-nummer',
    productName: 'Namn',
    strength: 'Styrka',
    activeSubstancesDescription: 'Aktiv substans',
    manufacturerName: 'Tillverkare',
    availableForCustomers: 'Tillgänglighet',
    halving: 'Delbar i dosdispensering',
    halvable: 'Delbar',
    alwaysHalvable: 'Endast delbar',
    available: 'Tillgänglig',
    inShortSupply: 'Håller på att ta slut',
    outOfStock: 'Slut',
    toBeDiscontinued: 'Kommer att tas bort från sortimentet',
    discontinued: 'Finns inte längre i sortimentet',
    drugFormatDescription: 'Läkemedelsform',
    tabletSplit: 'Delbarhet',
    crushable: 'Krossbarhet',
    additionalDosageInformation: 'Ytterligare doseringsinformation',
    lactose: 'Laktos',
    medicineManual: 'Läkemedelsguide',
    medicineType: 'Typ av product',
    showMoreInfo: 'Visa detaljer',
    closeMoreInfo: 'Stäng detaljer',
    searchManufacturer: 'Sök tillverkaren',
    pharmaceuticalGroup: 'Läkemedelsgrupp',
    substituteProduct: 'Ersättande produkt',
    drug: 'Narkotika',
    psychoClass: 'PKV läkemedel',
    trafficHazard: 'Påverkar körförmågan',
    fimeaClass: 'Medicin75+ klass + kommentar (Fimea)',
    activeSubstance: 'Aktiv substans',
    takingTheMedicine: 'Administrering',
    influence: 'Verkningsmekanism',
    dosage: 'Dosering',
    purpose: 'Indikation',
    sideEffects: 'Biverkningar',
    pregnancy: 'Graviditet och amning',
    storage: 'Förvaring',
    appearance: 'Utseende',
    unknown: 'Information ej tillgänglig',
    filters: {
      Available: 'Tillgänglig',
      InShortSupply: 'Håller på att ta slut (svårigheter med tillgänglighet)',
      OutOfStock: 'Slut (svårigheter med tillgänglighet)',
      ToBeDiscontinued: 'Kommer att tas bort från sortimentet',
      Discontinued: 'Finns inte längre i sortimentet',
      halvingYes: 'Delbar',
      halvingNo: 'Ej delbar',
      halvingAlways: 'Endast delbar',
      drug: 'Läkemedel',
      supplement: 'Kosttillskott',
    },
    isHalvable: {
      '2': 'Endast delbar',
      '1': 'Delbar',
    },
    isSplittable: {
      '0': 'Får ej delas',
      '1': 'Får delas',
      '2': 'Endast för att underlätta sväljning',
      '3': 'Information ej tillgänglig',
      '4': 'Får ej delas',
      '5': 'Får delas',
      '6': 'Endast för att underlätta sväljning',
      '7': 'Information ej tillgänglig',
      '9': 'Information ej tillgänglig',
    },
    isLactose: {
      '0': 'Innehåller inte laktos',
      '1': 'Innehåller laktos',
    },
    isCrushable: {
      '0': 'Får ej krossas',
      '1': 'Får krossas',
      '9': 'Information ej tillgänglig',
    },
  },
  customer: {
    title: 'Mitt kundkonto',
    customerInfo: 'Företagsinformation',
    customerUserList: 'Användare',
    businessName: 'Företags namn',
    businessId: 'FO-nummer',
    taxCode: 'Momsnummer',
    invoiceAddress: 'Faktureringsadress',
    operatorId: 'Operatörs-ID',
    doseDeliveryContactPerson: 'Kontaktperson för dosdispensering',
    kelaNumber: 'FPA-nummer',
    doseDeliveryEmailAddress: 'E-post för dosdispensering',
    doseDeliveryPhoneNumber: 'Telefonnummer för dosdispensering',
    invoicingInfo: 'Faktureringsuppgifter',
    deliveryInfo: 'Leveransinformation',
    pharmacyInfo: 'Apoteksinformation',
    addUser: 'Lägg till anvandäre',
    inviteLinks: 'Inbjudningslänkar',
    pharmacist: 'Farmaceut',
    removeUser: 'Radera användaren',
    removeUserTitle: 'Radera användaren',
    removeUserDesc:
      'Du håller på att ta bort ett  användarkontot från OmaPro Portalen. Efter borttagningen får användaren inte längre tillgång till OmaPro Portalen. Vill du ta bort användarkontot?',
    roles: {
      'customer-pharmacist': 'Farmaceut',
      'customer-user': 'Användare',
      'customer-user-management': 'Användarhantering',
      'customer-view-orders': 'Dosdispenseringsbeställningar',
      'customer-buyer': 'Inköpsbehörighet',
      'invoice-viewing': 'Behörighet att visa fakturor',
      'company-information-management': 'Administrera företagsuppgifter',
      'contract-information-viewing': 'Behörighet att visa avtalsuppgifter',
    },
    newUser: 'Ny användare',
    sendInviteLink: 'Skicka inbjudningslänk',
    newUserModalTitle: 'Lägg till ny användare',
    newUserModalDescription: 'Du har skickat en inbjudningslänk till följande e-postadress:',
    newInviteLinkExpiresIn: 'Inbjudningslänken är giltig i 60 minuter.',
    ordersApiKeyTooltip:
      'Lösenordet kan endast ändras via Portalen av kundkontots huvudanvändaren.',
    ordersApiKeyTitle: 'Lösenord för beställningsgränssnittet',
    ordersApiKeyDisclaimer:
      'Påbörja byte av lösenord för beställningsgränssnittet genom att klicka på knappen Skapa nytt lösenord. När du har bekräftat, visas det nya lösenordet i fältet nedan, så att du kan kopiera det till urklipp. Det nya lösenordet träder i kraft omedelbart och måste uppdateras i apotekssystemet direkt efter återställningen.',
    ordersApiKeyResetButton: 'Skapa nytt lösenord',
    ordersApiKeyCopyToClipboard: 'Kopiera till urklipp',
    ordersApiKeyModalDisclaimer:
      'Du håller på att skapa ett nytt lösenord för beställningsgränssnittet. Det nya lösenordet träder i kraft omedelbart och måste uppdateras i apotekssystemet direkt efter återställningen. Vill du fortsätta?',
    ordersApiKeyModalOkButton: 'Skapa nytt lösenord',
    ordersApiKeyModalTitle: 'Byte av lösenord för beställningsgränssnittet',
    reports: {
      reports: 'Rapporter',
      reportType: 'Rapporttyp',
      download: 'Ladda ner rapport',
      formReport: 'Skapa rapport',
      noReportToShow: 'Ingen rapport att visa',
      timeInterval: 'Tidsintervall',
      purchaseReport: 'Inköpsrapport',
      productBreakdown: 'Specifikation per produkt',
      customerGroupBreakdown: 'Specifikation per kundgrupp',
      timeIntervalTooltip:
        'Välj ett tidsintervall på högst 31 dagar. Rapporten baseras på leveranser under det valda tidsintervallet.',
      reportTypeTooltip:
        'Specifikation per kundgrupp = Orderuppgifter per kundgrupp. Inköpsrapport = Produkter uppdelade i apoteksskattepliktiga och skattefria produkter.',
      modalTitle: 'Rapporten skapas, vänligen vänta en stund.',
    },
  },
  customerService: {
    customerInfoLink: 'Customer info',
    customerSelectInput: {
      placeholder: 'Valitse asiakas',
      searchInstruction: 'Syötä vähintään 3 merkkiä',
    },
  },
  extranetCard: {
    buttonLabel: 'Läs mer',
  },
  orderHistory: {
    title: 'Beställningshistorik',
    orderCount: 'Beställningar',
    select: 'Välj',
    orderDate: 'Beställningsdatum',
    customerGroup: 'Kundgrupp',
    groupOrderCount: 'Beställningsmängd',
    orderState: 'Beställningsstatus',
    name: 'Namn',
    dateOfBirth: 'Födelsedatum',
    subscriptionPeriod: 'Beställningsperiod',
    orderNumber: 'Beställningsnummer',
    comments: 'Anteckningar',
    deliveryDate: 'Avsändningsdatum',
    orderChanges: 'Orderändringar',
    orderChange: 'Orderändring',
    urgent: 'Expressbeställning',
    productNumber: 'Produktnummer',
    showOrderChanges: 'Visa endast beställningar med ändringar',
    status: {
      arrived: 'Mottagen',
      'in-manufacturing': 'I produktion',
      'missing-information': 'Väntar på information',
      sent: 'Skickad',
      cancelled: 'Avbruten',
    },
    listOfChangesButton: 'Listning av ändringar',
    dosageCards: 'Dosdispenseringskort',
    dosageCardButtonMobileTooltip:
      'Beställningens status måste vara "Skickad" för att kunna skrivas ut.',
    dosageCardButtonTooltip:
      'Välj de beställningar eller kundgrupper som ska skrivas ut. Beställningens status måste vara "Skickad" för att kunna skrivas ut.',
    orderChangesButtonTooltip:
      'Välj de beställningar vars ändringar du vill se eller skriva ut. Minst en beställning med ändringar måste vara vald. Listan öppnas i ett separat fönster.',
    vnrSearchPlaceholder: 'Filtrera efter produktnummer',
  },
  productShortages: {
    title: 'Läkemedelsbrister',
    noShortages: 'Inga läkemedelsbrister',
    allGood: 'Allt är i ordning!',
    subscriptionPeriodInfo:
      'Listan visar de kunder vars senaste beställningsperiod har innehållit en produkt som kräver uppmärksamhet.',
    replaceableProduct: 'Ersättningsprodukt',
  },
  inviteLinks: {
    openInvites: 'Öppna inbjudningslänkar',
    inviteCreator: 'Skapare av inbjudningslänk',
    InvitationLinkRecipientEmail: 'Mottagarens e-post för inbjudningslänken',
    expires: 'Går ut',
    usable: 'Tillgänglig',
    roles: 'Användarroller',
    cancelInviteLink: 'Avbryt inbjudningslänk',
    cancelInviteLinkModal: 'Avbokning av inbjudningslänk',
    cancelInviteLinkDescription: 'Är du säker på att du vill avbryta inbjudningslänken till: ',
    cancelInviteLinkSuccess: 'Kutsulinkki poistettu onnistuneesti',
    signUpToExtranet: 'Logga in på OmaPro Portalen',
    inviteLinkExpired: 'Din inbjudningslänk är inte giltig.',
    inviteLinkAskNew: 'Begär en ny inbjudningslänk för att fortsätta inloggningen.',
    toSignin: 'Gå till inloggningssidan',
    registration: {
      title: 'Välkommen till OmaPro Portalen',
      subtitle: 'Registrera dig genom att fylla i uppgifterna nedan',
      usernamePlaceholder: 'Skriv in användarnamn',
      usernameMaxLengthError: 'Användarnamnet får vara högst 32 tecken långt',
      usernameMinLengthError: 'Användarnamnet måste vara minst 5 tecken långt',
      usernamePatternError: 'Användarnamnet får inte innehålla mellanslag',
      passwordAgain: 'Lösenord igen',
      passwordPlaceholder: 'Minst 15 tecken',
      passwordMinLengthError: 'Lösenordet måste vara minst 15 tecken långt',
      passwordsDoNotMatch: 'Lösenordet matchar inte',
      passwordPatternError:
        'Lösenordet måste innehålla stora och små bokstäver, siffror och specialtecken',
      userNameTooltip:
        'Skapa ett säkert och lätt att komma ihåg användarnamn genom att använda små bokstäver och siffror. Undvik personliga uppgifter och använd inte samma användarnamn i olika tjänster. Användarnamnet får inte innehålla specialtecken eller bokstäverna å, ä eller ö.',
      passwordTooltip:
        'Lösenordet måste vara minst 15 tecken långt och innehålla stora och små bokstäver, siffror och specialtecken',
      marketingAuthorizationInfo:
        'Med detta samtycke håller du dig uppdaterad om nya produkter, tjänster och erbjudanden som kan vara av intresse för dig. Du kan när som helst dra tillbaka samtycket.',
      privacyPolicyInfo:
        'Läs hur vi behandlar dina uppgifter på ett säkert och konfidentiellt sätt. Acceptera meddelandet för att fortsätta.',
      extranetPrivacyPolicy: 'OmaPro Portal dataskyddsbeskrivning',
      extranettermsOfUse: 'OmaPro Portal användarvillkor',
      newUserSuccess: 'Ny användare har skapats framgångsrikt',
      newUserError: 'Skapandet av ny användare misslyckades',
      newUserNameConflict: 'Användarnamnet är redan taget',
      emailTooltip:
        'E-postadressen som används är den adress som inbjudan har skickats till. E-postadressen kan ändras i efterhand i egna uppgifter.',
      countryTooltip: 'Ange landskoden, t.ex. Finlands landskod "FI", enligt ISO 3166-standarden.',
      selectProfessionalRoleTitle: 'Välj yrkesroller',
      selectProfessionalRoleInfo:
        'Yrkesroller påverkar det innehåll du ser och utökar ditt materialutbud. Genom att välja en yrkesroll bekräftar du att du är behörig att ha tillgång till innehåll som är avsett för den målgruppen.',
      noSelectedProfessionalRole: 'Ingen yrkesroll',
    },
  },
  customerGroupSettings: {
    title: 'Administration av kundgruppen',
    update: 'Redigering av kundgrupper',
    customer: 'Kund',
    activity: 'Aktivitet',
    selectPricing: 'Välj dosdispenseringsavgift',
    activityTooltip:
      'Gruppens status är aktiv när beställningar har gjorts under de senaste 8 veckorna.',
    doseDispensingFee: 'Avgift för dosdispensering',
    doseDispensingFeeNotSet: 'Avgift för dosdispensering inte inställt',
    doseDispensingFeeTooltip:
      'Ange en avgift för dosdispensering för gruppen. Avgiften bestäms av prissättningsavtalet.',
    orderTime: 'Beställningstid',
    orderTimeNotSet: 'Beställningstid inte inställd',
    orderTimeTooltip:
      'Ange en beställningstid för gruppen. Vänligen kontakta vår kundtjänst innan du ställer in en beställningstid om du planerar att starta en stor mängd (över 50 kunder) samtidigt eller vill införa en ny beställningsdag. Observera att beställningstiden endast bör ändras av viktiga skäl i framtiden.',
    doseBagLayout: 'Utseende på dospåsar',
    doseBagLayoutTooltip:
      'Välj "Iso printti" om du vill att alla kunder i gruppen ska få större text på datum- och tidsinformationen på dospåsarna.',
    disclosure: 'Utlämnande av uppgifter',
    disclosureTooltip:
      'Genom att välja en tredje part från menyn nedan ger du dosdispenseringsenheten rätt att dela nödvändiga dosdispenseringsdata för slutanvändaren med den parten. Observera att Smila-läkemedelsautomat kräver viss information från dospåsarna för att fungera.',
    stickerlessGroup: 'Etikettfri grupp',
    stickerlessGroupTooltip:
      'Välj "Etikettfri grupp" om du vill att alla gruppens rullar ska vara utan fästetiketter.',
    nextOrderDeadline: 'Nästa beställningstid',
    selectedOrderDeadline: 'Vald beställningstid',
    selectableOrderDeadline: 'Tillgänglig beställningstid',
    noSelectableTimes: 'Inga valbara tider',
    smilaGroupSticker:
      'Smila-gruppen måste vara utan etiketter. Gå tillbaka och välj etikettfri grupp.',
    updateModal: {
      title:
        'Obs! Du håller på att ändra inställningarna för kundgruppen. De nya inställningarna träder i kraft vid nästa beställning.',
      content:
        'Observera att produktionsvolymerna övervakas noggrant och att beställningstiden endast bör ändras av vägande skäl. Vänligen kontakta vår kundtjänst i god tid före ändringsdatumet om ändringen gäller ett stort antal (över 50 kunder) samtidigt.',
      confirmation: 'Vill du spara ändringarna för kundgruppen?',
    },
    normalLayout: 'Normal',
    bigFontLayout: 'Iso Printti',
    notSet: 'Inte inställt',
    scheduleNotSet: 'Inget schema inställt',
    groupUpdatedSuccessfully: 'Gruppen har redigerats framgångsrikt',
    contract: 'Avtal',
    dataRelease: 'Ej utlämnas',
    nextOrderTime: {
      notSet: 'Ej angivet',
      nextOrderDeadline: 'Nästa beställningstid',
      selectedOrderDeadline: 'Vald beställningstid',
      availableOrderDeadline: 'Tillgänglig beställningstid',
    },
    nextOrderDeadlineTooltip:
      'Detta är en förutspådd beställningstid enligt den ordinarie tidtabellen och tar inte hänsyn till eventuella separat överenskomna avvikande tidtabeller eller helgdagar. Vänligen kontrollera de detaljerade beställningstidtabellerna på sidan "Beställningstidtabell / Avvikelser i tidtabellen".',
  },
  unauthorized: {
    welcome: 'Välkommen till OmaPro Portalen',
    redirect: 'Du omdirigeras automatiskt om 10 sekunder',
    noAuth: 'Ingen åtkomst',
    noLink: 'Inget kundkonto är kopplat till användarnamnet',
  },
  physicalProducts: {
    orderMaterialTabTitle: 'Materialbeställning',
    orderedMaterialTabTitle: 'Beställda material',
    totalPrice: 'Totalt pris',
    total: 'Totalt',
    vat: 'Moms',
    vatLowercase: 'moms',
    priceByPcs: 'À-pris',
    orderDate: 'Beställningsdatum',
    shoppingCartButton: 'Beställ',
    freeMaterial: 'Kostnadsfri',
    priceTooltip:
      'Materialen faktureras i samband med nästa dosdispenseringsbeställning. För att beställa avgiftsbelagt material krävs en inköpsbehörighet.',
    quantityTooltip:
      'Max 30 st per material kan beställas. Vid behov av större mängd, kontakta din representant innan beställning.',
    shoppingCart: {
      title: 'Beställningssammanfattning',
      sendOrder: 'Skicka beställning',
      footerMessage: 'Beställda material levereras med nästa dosdispenseringsleverans.',
      orderSuccess: 'Beställningen skickades framgångsrikt',
    },
  },
  correctionRequests: {
    titleTooltip:
      'En korrigeringsförfrågan skickas om en produkt i beställningen plötsligt har tagits ur produktion. Då ska en ny beställning göras till kunden så snart som möjligt, utan att markera den som expressbeställning. När den nya beställningen har lagts, ska korrigeringsförfrågan markeras som behandlad under fliken Aktiva förfrågningar.',
    activeRequests: 'Aktiva förfrågningar',
    checkedRequests: 'Kvitterade förfrågningar',
    requestArrivedAt: 'Korrigeringsförfrågan har inkommit',
    missingProduct: 'Ej tillgänglig produkt',
    substituteProduct: 'Ersättande produkt',
    requestCheck: 'Korrigeringsförfrågan har kvitterats',
    requestCheckByPharmac: 'Korrigeringsförfrågan har gått ut',
    requestCheckTooltip:
      'Genom att kvittera korrigeringsförfrågan bekräftar du att förfrågan har behandlat och att en ny beställning har lagts.',
    requesCheckedBy: 'Korrigeringsförfrågan kvitterad',
    requesCheckedSuccess: 'Korrigeringsförfrågan kvitterad framgångsrikt',
    noCorrectionRequests: 'Inga korrigeringsförfrågningar',
    customerName: 'Kundens namn',
    searchByName: 'Sök med namn',
  },
  contact: {
    openTicketsTabTitle: 'Öppna konversationer',
    closedTicketsTabTitle: 'Stängda konversationer',
    startNewTicketButton: 'Starta en ny konversation',
    newTicketModalTitle: 'Ny konversation',
    newTicketModalInfo:
      'Ni kan använda denna säkra kanal för att kontakta oss i alla ärenden. Vi besvarar meddelanden under kundtjänstens öppettider.',
    subject: 'Ämne',
    subjectAreaLabel: 'Ämnesområde',
    subjectAreaInfo: 'Välj det ämnesområde som bäst beskriver ditt ärende.',
    confidentialTicketButton: 'Innehåller känslig information',
    confidentialTicketInfoLinkText: 'Dataskyddsbeskrivningen',
    privateTicketButton: 'Privat konversation',
    privateTicketInfo: 'Den privata konversationen är synlig endast för dig och kundservicen.',
    confidentialTicketInfo:
      'Markera meddelandet som känsligt om det innehåller till exempel identifierbara personuppgifter. Beskrivningen av konversationen, bilagorna och kommentarerna raderas i enlighet med den lagringsperiod som anges i dataskyddsbeskrivningen.',
    state: 'Status',
    createdAt: 'Skapad',
    updatedAt: 'Uppdaterad',
    writer: 'Författare',
    description: 'Beskrivning',
    attachments: 'Bilagor',
    addAttachment: 'Bifoga fil',
    comments: 'Kommentarer',
    addComment: 'Lägg till kommentar',
    sendButton: 'Skicka',
    reopenTicket: 'Återöppna konversation',
    cancelTicket: 'Avbryt konversation',
    cancelTicketModal:
      'Vill du verkligen avbryta konversationen? Välj "Avbryt konversation" om den är onödig. En avbruten konversation kan inte öppnas igen.',
    closeTicket: 'Avsluta konversationen',
    closeTicketModal:
      'Är du säker på att du vill avsluta konversationen? Välj "Avsluta konversationen" när du har fått svar på ditt ärende och det är löst. Avslutade konversationer kan vid behov öppnas på nytt inom 5 dagar.',
    new: 'Ny',
    inProgress: 'Under behandling',
    repliedByPharmac: 'Svar från Pharmac',
    closed: 'Stängd',
    cancelled: 'Avbruten',
    resolved: 'Klar',
    commentAddedToast: 'Kommentar tillagd',
    noComments: 'Inga kommentarer ännu',
    wrongFileTypeError: 'Fel filformat, tillåtna filformat är .pdf, .jpg, .png, .webp',
    acceptableFileTypes: 'Tillåtna filformat: .pdf, .jpg, .png, .webp',
  },
  orderSchedules: {
    titleTooltip:
      'Om ni önskar ändringar i de planerade tidtabellsavvikelserna, vänligen kontakta Pharmac via kontaktformuläret',
    onlyExceptionsSwitch: 'Visa endast avvikelser',
    orderPrediction: 'Beställnings-prognos',
    exceptions: 'Avvikelser',
    periodLength: 'Periodens längd',
    atThePharmacy: 'Levererad till apoteket',
    double: 'Dubbling',
    transfer: 'Flytt',
    noExceptions: 'Inga avvikelser',
    doubledOffDate: 'Fördubblad från dagen',
    transferedOffDate: 'Flyttad bort från dagen',
    includesExceptions: 'Innehåller avvikelser',
    expectionDate: 'Avvikande beställningstid',
    movedFromDate: 'Flyttad från dag',
    movedFromDates: 'Flyttad från dagar',
    doubledFromDate: 'Fördubblad från dagen',
    doubledFromDates: 'Fördubblad från dagar',
    removedFromDate: 'Borttagen från dagen',
    noExceptionSchedules: 'Inga avvikande tidtabeller',
    noOrderSchedulesDesc:
      'Gör din första beställning och ange tidtabeller så att prognoser för beställningstidtabeller blir synliga.',
    days: 'dygn',
    removed: 'Borttagning',
  },
  billedDeliveries: {
    deliveryNumber: 'Leveransnummer',
    shippingDate: 'Avsändningsdatum',
    deliveryBreakdown: 'Produkt- och ordervis specifikation',
    orderBreakdown: 'Ordervis specifikation och inköpsrapporten',
    searchByDeliveryNumber: 'Sök med leveransnummer',
    deliveryBreakdownTooltip:
      'Välj den utskrivbara specifikationen per produkt och order. På grund av den stora filstorleken kan du endast ladda ner en specifikation åt gången. Om du väljer flera rader inaktiveras nedladdningsknappen.',
    orderBreakdownTooltip:
      'Välj de utskrivbara specifikationerna och inköpsrapporter per order. På grund av de stora filstorlekarna kan du ladda ner högst 10 specifikationer åt gången. Om du väljer fler än 10 rader är nedladdningsknappen inte tillgänglig.',
  },
  shop: {
    allProducts: 'Alla produkter',
    wholeCatalog: 'Hela sortimentet',
    ownProducts: 'Mina produkter',
    noOwnProducts:
      'Hej! De tillgängliga instruktionerna, guiderna, webbinarierna, avtalsmallarna och utbildningarna kan du skaffa via OmaPro Portalens butik. När du har skaffat materialet hittar du dem alltid samlat här.',
    noBuyerRoleTooltip: 'Du har ingen inköpsbehörighet. Vänligen kontakta huvudanvändaren.',
    purchaseRightDeniedTooltip: 'Köp ej tillåtet',
    noRequiredProfRolesTooltip: 'Du har inte den yrkesroll som krävs för att aktivera produkten',
    noRequiredProfRolesForDownloadTooltip:
      'Sinulla ei ole tuotteen lataamiseen tarvittavaa ammattiroolia',
    published: 'Publicerad',
    availableIndefinitely: 'Obegränsat att titta på',
    addedToOwnProducts: 'Tillagd i mina produkter',
    removedFromOwnProducts: 'Produkten har tagits bort från mina produkter',
    cart: {
      emptyCartTitle: 'Din varukorg är tom',
      emptyCartDesc:
        'Utforska vårt sortiment av produkter och tjänster. Du kan köpa produkter genom att lägga dem i din varukorg.',
      emptyCartButton: 'Gå till butiken',
      acceptTerms: 'Jag godkänner köpvillkoren och leveransvillkoren. Läs villkoren ',
      here: 'här.',
      missingRoles:
        'Du kan köpa den här produkten, men du kan inte aktivera den eftersom du saknar den yrkesroll som krävs. Ta bort produkten från varukorgen eller fortsätt med beställningen om du köper produkten som gåva.',
      orderSendSuccess: 'Beställningen har skickats framgångsrikt',
      totalPrice: 'Momsfritt totalt',
    },
    filters: {
      order: 'Ordning',
      alphabetically: 'Alfabetiskt',
      newest: 'Nyast först',
      oldest: 'Äldst först',
      cheapest: 'Billigast först',
      mostExpensive: 'Dyrast först',
      priceType: 'Pristyp',
      fee: 'Avgiftsbelagd',
      free: 'Gratis',
      tags: 'Taggar',
    },
    removeProductModal: {
      title: 'Ta bort produkt',
      description:
        'Du håller på att ta bort en produkt från Mina produkter. Du kan när som helst lägga till produkten igen från fliken Alla produkter.',
    },
    product: {
      viewable: 'Tillgänglig att titta på',
      till: 'till',
      unlimitedAccess: 'Obegränsat att titta på',
      preview: 'Förhandsvisningsvideo',
      notActivated: 'Produkten har inte aktiverats',
      requiredRoles: 'Nödvändiga yrkesroller',
      noRequiredRoles: 'Utan begränsningar',
      activated: 'Produkten har aktiverats',
      videoNotAvailable: 'Videon är inte tillgänglig',
      pictureNotAvailable: 'Bilden är inte tillgänglig',
    },
    buttons: {
      buyAgain: 'Beställ igen',
      learnMore: 'Utforska',
      addToCart: 'Lägg i varukorgen',
      removeFromCart: 'Ta bort från varukorgen',
      addToOwnProducts: 'Lägg till i mina produkter',
      goTo: 'Fortsätt',
      downloadDocument: 'Ladd ner dokumenta',
      activate: 'Aktivera',
      activeteProduct: 'Aktivera produkt',
      downloadTemplate: 'Ladda ner',
    },
    activateCodeModal: {
      title: 'Aktivera produktkod',
      addCode: 'Ange kod',
      customer: 'Du aktiverar produkten som kund hos',
      usageTime: 'Användningstid',
      roleError:
        'Du har inte den yrkesroll som krävs för att aktivera produkten. Du hittar de nödvändiga yrkesrollerna i produktbeskrivningen.',
      codeError: 'Den inslagna koden är fel',
      expiredError: 'Produkten kan inte längre aktiveras',
      usedError: 'Aktiveringskoden har redan använts',
      activatedError: 'Produkten är redan aktiverad',
      activateProductSuccess: 'Produkten har aktiverats framgångsrikt',
    },
    orders: {
      shopOrders: 'Webbutiksbeställningar',
      orderNumber: 'Beställningsnummer',
      orderDate: 'Beställningsdatum',
      orderStatus: 'Beställningsstatus',
      totalPrice: 'Pris totalt exkl. moms',
      purchaserName: 'Köpare',
      statuses: {
        arrived: 'Mottagen',
        cancelled: 'Avbeställd',
        beingProcessed: 'Under behandling',
        delivered: 'Leverad',
        partiallyDelivered: 'Delvis levererad',
        completed: 'Färdig',
        sent: 'Skickad',
      },
      orderRow: 'Beställningsrad',
      productName: 'Produktnamn',
      quantity: 'Antal',
      unitPrice: 'À-pris',
      status: 'Status',
      deliveryNumber: 'Leveransnummer',
      codes: {
        externalUser: 'Extern användare',
        used: 'Använd',
        unused: 'Oanvänd',
        activationCodes: 'Aktiveringskoder',
        copy: 'Kopiera',
      },
    },
  },
  shopProducts: {
    document: 'Dokument',
    video: 'Video',
    videos: 'Videoinspelningar',
    documents: 'Dokument',
    serviceProduct: 'Tjänst',
    serviceProducts: 'Tjänster',
    physicalProduct: 'Tilläggsprodukt',
    materialType: 'Materialtyp',
    releaseDateRange: 'Publiceringsintervall',
    description: 'Beskrivning',
    chapters: 'Delar',
    goTo: 'Fortsätt',
    downloadDocument: 'Ladd ner dokumenta',
    relatedProducts: 'Tilläggsprodukter',
  },
  footer: {
    contact: 'Kontakta oss',
    links: 'Länkar',
    privacyPolicy: 'Dataskyddsbeskrivningen',
    termsOfUse: 'Användarvillkor',
    shopTermsAndConditionsOfContractAndDelivery: 'Avtals- och leveransvillkor för webbutiken',
    oivaReport: 'Oiva-rapport',
  },
}

export const commonSv: CommonTranslation = {
  greeting: 'Hej',
  yes: 'Ja',
  no: 'Nej',
  welcome: 'Välkommen',
  home: 'Hem',
  users: 'Användare',
  orders: 'Beställningar',
  pharmacies: 'Apotek',
  taksa: 'Taxa',
  catalog: 'Produktkatalog',
  admin: 'Underhåll',
  accept: 'Acceptera',
  settings: 'Inställningar',
  logout: 'Logga ut',
  login: 'Logga in',
  signUp: 'Registrera dig',
  deleted: 'Raderat',
  arrived: 'Anlänt',
  return: 'Återgå',
  search: 'Sök...',
  noSearchResultsTitle: 'Inga resultat',
  noSearchResultsDescription: 'Kontrollera eller utvidga dina sökkriterier',
  notFoundPageTitle: 'Etsimääsi sivua ei löydy!',
  notFoundPageMessage: 'Siirry etusivun tai valikon kautta haluamallesi sivulle.',
  filters: 'Filter',
  category: 'Kategori',
  categories: 'Kategorier',
  favourite: 'Favorit',
  firstName: 'Förnamn',
  lastName: 'Efternamn',
  phoneNumber: 'Telefonnummer',
  streetName: 'Gatuadress',
  emailAddress: 'E-post',
  postCode: 'Postnummer',
  townName: 'Postkontor',
  userName: 'Användarnamn',
  countryCode: 'Landskod',
  country: 'Land',
  certificateCardNumber: 'Certifikatkort nummer',
  clipboardSuccess: '',
  clipboardError: '',
  password: 'Lösenord',
  changePassword: 'Ändra lösenord',
  cancel: 'Avbryta',
  save: 'Spara',
  basicInfo: 'Basuppgifter',
  contactPersonName: 'Kontaktperson',
  edit: 'Ändra',
  moreInfo: 'Mer information',
  week: 'Vecka',
  selectDateRange: 'Ställ in datumintervall',
  selectDate: 'Aseta päivämäärä',
  endDateText: 'Slutdatum',
  startDateText: 'Startdatum',
  clock: 'kl.',
  pcs: 'st.',
  continue: 'Fortsätt',
  alternateWeek: 'Växelvecka',
  requiredFieldError: 'Obligatorisk uppgift',
  emailPatternError: 'Ogiltig e-postadress',
  active: 'Aktiv',
  passive: 'Passiv',
  monday: 'Måndag',
  tuesday: 'Tisdag',
  wednesday: 'Onsdag',
  thursday: 'Torsdag',
  friday: 'Fredag',
  mondayShort: 'Mån',
  tuesdayShort: 'tis',
  wednesdayShort: 'ons',
  thursdayShort: 'tors',
  fridayShort: 'fre',
  saturdayShort: 'lör',
  sundayShort: 'sön',
  class: 'Klass',
  comment: 'Kommentar',
  chooseCustomer: 'Välj din representerade kund från listan nedan för att fortsätta.',
  timeoutTitle: 'Din session håller på att löpa ut',
  timeoutContent1: 'Du loggas ut automatiskt om',
  timeoutContent2: '. Vill du fortsätta använda OmaPro Portalen?',
  timeoutMinutes: 'minuter',
  timeoutSeconds: 'sekunder',
  all: 'Alla',
  nb: 'Obs!',
  name: 'Namn',
  quantity: 'Antal',
  price: 'Pris',
  professionalRoles: 'Yrkesroller',
  language: 'Språk',
  fi: 'Finska',
  sv: 'Svenska',
  en: 'Engelska',
  roles: 'Roller',
  free: 'Kostnadsfri',
  remove: 'Ta bort',
  dayShort: 'Dag',
  monthShort: 'Månad',
  yearShort: 'år',
  buyingBan: 'Köpförbud',
  einvoice: 'Elektronisk faktura',
  emailInvoice: 'E-postfaktura',
  printInvoice: 'Pappersfaktura',
}
